let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cOHcg")).then(() => parcelRequire('d0NM0'));